import React from "react";
import { PaziaButton, PaziaButtonProps, PaziaButtonType } from "./PaziaButton";
import { useFormContext } from "react-hook-form";

export interface PaziaFormButtonProps extends Omit<PaziaButtonProps, "type"> {
  allowCleanSubmit?: boolean;
  type?: PaziaButtonType;
}

export const PaziaFormButton = ({
  allowCleanSubmit = false,
  disabled,
  type = "success",
  ...rest
}: PaziaFormButtonProps): JSX.Element => {
  const {
    formState: { isSubmitting, isDirty },
  } = useFormContext();
  return (
    <PaziaButton
      {...rest}
      processing={isSubmitting}
      title={rest.title ?? "Zapisz"}
      type={type}
      disabled={disabled ? disabled : allowCleanSubmit ? false : !isDirty}
    />
  );
};
